const en_US = {
  translations: {
    page: {
      totem_start: {
        environment: "Environment",
        code: "Code",
        password: "Password",
        enter: "Enter",
        version: "Version",
        developed_by: "Developed by ",
        platform: "Platform 4uHub",
        errors: {
          environment: "Environment is mandatory",
          login: "Login is mandatory",
          password: "Password is mandatory",
        },
      },
      mainMenu: {
        welcome: "Welcome",
        need_help: "I will need help to be served:",
        password_button: "Password queue attendance",
        can_do_it: "I can do my service alone:",
        check_in_button: "Check-In",
        schedule_button: "Scheduling consultations and exams",
        totem: "Service Totem",
        thanks: "Thank you for using our service!",
      },
      login: {
        welcome: "Welcome back",
        username: "Username",
        cpf: "CPF",
        password: "Password",
        rememberme: "Remember me",
        forget_password: "Forgot password?",
        dont_account: "Don't have an account? Register",
        login: "Login",
        confirm_email: "Confirm email",
        errors: {
          login: "The login is mandatory",
          password: "Password must be at least 6 characters long",
        },
      },
      loginTemporary: {
        welcome: "Welcome",
        login: "Login",
        password: "Password",
        dont_account: "Don't have an account? Register",
        access_button: "Access",
        access_exam: "Access exams",
        errors: {
          login: "The login is mandatory",
          password: "The password is mandatory",
        },
      },
      not_found: {
        page_not_found: "Ooops! Page not found",
        server_not_responding: "Server not responding",
        try_again: "Try Again",
        back_to_begin: "Back to home",
        back_to_login: "Back to login",
        something_went_wrong: "Something went wrong",
      },
      documents: {
        title: "Terms and Policies",
        subtitle: "These are the documents you accepted",
        no_docs:
          "You have not accepted any documents yet. After accepting any document it will appear here",
      },

      register: {
        register: "Register",
        document: "Document",
        has_register: "Already registered? Access your account",
        birth_date: "Birth Date",
        email: "Email",
        confirm_email: "Confirm email",
        password: "Password",
        confirm_password: "Confirm password",
        notification: "Registered successfully",
        errors: {
          document: "The document is mandatory",
          password: "The password is mandatory",
          email: "The email is mandatory",
          confirm_email: "The emails must match",
          confirm_password: "The passwords must match",
          birth_date: "The birth date is mandatory",
        },
        emailSendMessage:
          "We send an email to confirm the account creation.Please check the spam tab :)",
        backToLogin: "Go back to the login",
        individuals: {
          contacts: "Contacts",
          contact_type: "Contact type",
          add_contact: "Add contact",
          addresses: "Addresses",
          add_address: "Add address",
        },
      },
      changePassword: {
        change_password: "Change password",
        actual_password: "Actual password",
        new_password: "New password",
        save: "Save",
        confirm_new_password: "Confirm new password",
        success_message: "Password changed successfully",
        errors: {
          actual_password: "The actual password is mandatory",
          new_password: "The new password is mandatory",
          confirm_new_password: "The confirm password is mandatory",
          passwords_match: "Passwords do not match",
        },
      },
      confirm_email: {
        confirm_email: "Confirm email",
        confirming: "Confirming",
        resent: "Email resent successfully",
        success: {
          title: "Confirmed email",
          description:
            "Your email has been successfully confirmed, go back to the login to access your account",
        },
        subtitle:
          'Enter the code received by email below and then click "Confirm email".',
        username: "Username",
        document: "CPF",
        code: "Code",
        error: {
          title: "There was an error",
          description: "An error occurred when confirming the email, try again",
          action: "Forward email",
          username: "The {{username}} is mandatory",
          code: "The code is mandatory",
        },
      },
      noAccess: {
        message:
          "Oops! It looks like you don't have permission to access this page!",
        button: "Back to home",
      },
    },
    components: {
      backButton: "Back",
      private: {
        permission: "Ooops! You don't have permission!",
      },
      themeSwitch: {
        change_theme: "Change Theme",
      },
      languageSwitch: {
        change_language: "Change language",
      },
      recents: {
        status: {
          analyze: "Under review",
          expiresToday: "Expires today",
        },
      },
      no_data: "No data to show",
      establishments: {
        select: "Select a establishment",
        change: "Change establishment",
      },

      changeLanguageForm: {
        title: "Change language",
        language: "Language",
        button: "Change",
      },
      autocomplete: {
        noOptions: "No options",
        hint: "Type at least 3 characters to search",
      },
      avatarDropdown: {
        tooltip_user: "Account settings",
        tooltip_visit: "Login",
      },
      forgetPasswordForm: {
        title: "Esqueceu a senha?",
        subtitle:
          "Enter your CPF below and we'll send you a code to your email to reset your password.",
        button: "Send",
        login: "CPF",
        login_required: "Email is required!",
        notification_email_sent: "Email sent successfully!",
        back_login: "Back to login",
        notification_email_confirmed:
          "Email confirmed successfully, please enter your access details again.",
      },
      resetPasswordForm: {
        title: "New password",
        subtitle:
          "Enter the code sent to your email. If you can't find it, check your spam area.",
        password: "Password",
        confirm_password: "Confirm password",
        confirmation_code: "Confirmation code",
        new_password_required: "Password is required.",
        confirm_new_password_required: "Confirm password is required.",
        passwords_match: "Passwords do not match.",
        confirmation_code_required: "The confirmation code is mandatory",
        notification_password_success: "Password changed successfully!",
        counter: "Resend email available in {{counter}} second(s)",
      },
      resendEmail: {
        title: "It looks like you haven't confirmed your email yet.",
        description: "Click the button below to resend the confirmation email.",
        button: "Resend email",
        success: "Email sent successfully!",
      },
      noRowsMessage: {
        no_permission: "You do not have permission to access this information",
        no_data: "No data to display",
      },
      accessTemporaryMessage: {
        access_temporary: "Temporary access",
        register: "Register to have access to all the resources of our portal",
        login: "Login to have access to all the resources of our portal",
        register_btn: "Register",
        login_btn: "Login",
      },
    },
    logout: "Logout",
    change_password: "Change password",
    change_language: "Change language",
    access_denied: "You need to be login, to access this page",
  },
};

export default en_US;
